import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import 'typeface-lato';

const theme = createMuiTheme({
  overrides: {
    MuiCard: {
      root: {
        borderRadius: 10
      }
    }
  },
  palette: {
    error: {
      main: '#F87070'
    },
    warning: {
      main: '#FFAA60'
    },
    info: {
      main: '#00B9F1'
    },
    success: {
      main: '#06BD7D'
    },
    primary: {
      main: '#004A65',
      50: '#D2F3FF',
      100: '#B0DDF5',
      200: '#91C2DF',
      300: '#6FA8C7',
      400: '#5593B5',
      500: '#3680A4',
      600: '#277192',
      700: '#145D7B',
      800: '#004A65',
      900: '#00354D'
    },
    secondary: {
      main: '#D3D800',
      50: '#FAFAE4',
      100: '#F3F3BD',
      200: '#EBEC91',
      300: '#E1E464',
      400: '#DADD3F',
      500: '#D3D800',
      600: '#C6C600',
      700: '#B4B000',
      800: '#A39900',
      900: '#867300'
    }
  },
  typography: {
    fontFamily: 'Lato',
    h4: {
      fontWeight: 500,
      fontSize: 24,
      letterSpacing: 0.17
    },
    h5: {
      fontWeight: 700,
      fontSize: 16
    },
    h6: {
      fontWeight: 700,
      fontSize: 14,
      letterSpacing: 0.17
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: 16,
      letterSpacing: 0.15
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: 14,
      letterSpacing: 0.1,
      lineHeight: '1.5rem'
    },
    overline: {
      fontWeight: 600,
      fontSize: 12,
      letterSpacing: 2,
      lineHeight: '1rem'
    },
    caption: {
      fontWeight: 600,
      fontSize: 12,
      letterSpacing: 0.4,
      lineHeight: '1rem'
    },
    body1: {
      fontWeight: 500,
      fontSize: 16,
      letterSpacing: 0.5,
      lineHeight: '1.75rem'
    },
    body2: {
      fontWeight: 400,
      fontSize: 14,
      letterSpacing: 0.25,
      lineHeight: '1.25rem'
    }
  }
});

function TemaProvider(
  {
    children
  }
) {
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}

export default TemaProvider;